import { RouteConfig } from 'vue-router'

const router: RouteConfig[] = [
  {
    path: '/administration',
    component: () => import('layouts/MainLayout.vue'),
    meta: {
      requiresAuth: true,
      requiresAdministrator: true
    },
    children: [
      {
        path: 'lessonplans',
        component: () => import('pages/Lessonplan/Index.vue'),
        children: [
          { path: 'new', component: () => import('pages/Lessonplan/CreateLessonPlan.vue') },
          { path: 'import', component: () => import('pages/Lessonplan/ImportLessonPlan.vue') },
          { path: ':lessonPlanId', component: () => import('pages/Lessonplan/CreateLessonPlan.vue') }
        ]
      },
      {
        path: 'lessonplans/:lessonId/prepare',
        component: () => import('pages/Lesson/Prepare/Index.vue')
      },
      // Upcoming screen
      {
        path: 'students',
        component: () => import('pages/Administration/Students.vue')
      },
      // Upcoming screen
      {
        path: 'teachers',
        component: () => import('pages/Administration/Teachers.vue')
      },
      // Upcoming screen
      {
        path: 'events',
        component: () => import('pages/Administration/Events.vue')
      },
      {
        path: 'announcements',
        component: () => import('pages/Announcements/Announcements.vue'),
        children: [
          {
            path: 'edit/:id',
            component: () => import('pages/Announcements/EditAnnouncement.vue')
          },
          {
            path: 'new',
            component: () => import('pages/Announcements/CreateAnnouncement.vue')
          }
        ],
        meta: { edit: true }
      },
      {
        path: 'sections',
        component: () => import('pages/Administration/Sections/Index.vue'),
        children: [
          {
            path: ':sectionId',
            component: () => import('pages/Administration/Sections/Detail.vue'),
            props: true
          }
        ]
      },
      {
        path: 'users',
        component: () => import('pages/Administration/Users/Index.vue'),
        children: [
          {
            path: ':userId',
            component: () => import('pages/Administration/Users/Detail.vue')
          },
          {
            path: 'new',
            component: () => import('pages/Administration/Users/Detail.vue')
          }
        ]
      },
      {
        path: 'tuitions',
        component: () => import('pages/Administration/TuitionTracker/Index.vue'),
        children: [
          {
            path: 'overview',
            component: () => import('pages/Administration/TuitionTracker/Overview.vue')
          },
          {
            path: ':tuitionId',
            component: () => import('pages/Administration/TuitionTracker/Detail.vue')
          }
        ]
      }
    ]
  }
]

export default router
